
import React from "react";
import {
  createBrowserRouter,
  RouterProvider,
  Route,
  Outlet,
  createRoutesFromElements,
  useLocation
} from "react-router-dom";

import Sidebar from './Navbar/Sidebar';
import Footer from './Navbar/Footer';

import Dashboard from './Components/Dashboard';
import Companies from './Components/Companies';
import Devices from './Components/Devices';
import Machine from './Components/Machine';
import Home from "./Components/Home";
import Login from "./Components/Login";
import User from "./Components/User";
import MachineIncharge from "./Components/MachineIncharge";

import "./App.css";

const AppLayout = () => {
  const location = useLocation();

  const hideSidebar =
    location.pathname === "/" ||
    location.pathname === "/machineIncharge";

  return (
    <div className="min-h-screen">

      {/* Sidebar */}
      {!hideSidebar && <Sidebar />}

      {/* Page Content */}
      <main>
        <Outlet />
      </main>

      {/* Common Footer */}
      <Footer />

    </div>
  );
};

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<AppLayout />}>

      <Route path="/" element={<Login />} />
      <Route path="/home" element={<Home />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/companies" element={<Companies />} />
      <Route path="/devices" element={<Devices />} />
      <Route path="/machine" element={<Machine />} />
      <Route path="/user" element={<User />} />
      <Route path="/machineIncharge" element={<MachineIncharge />} />

    </Route>
  )
);

const App = () => <RouterProvider router={router} />;

export default App;
